export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-004.dbd0b03a.jpg";